module.exports = __webpack_public_path__ + "static/media/FIND.d0ae8ee3.svg";